const uses = [
  {
    img: "focus.svg",
    title: "مقیاس‌پذیری",
    desc: "با خرید VPS کلاد در هر لحظه از سرویس و بسته به نیاز خود، منابع شامل تعداد هسته‌های پردازنده را کاهش یا افزایش دهید.",
    imgAlt: "مقیاس‌پذیری سرور مجازی ابری",
    imgTitle: "مقیاس‌پذیری وی پی اس",
  },

  {
    img: "reliability.svg",
    title: "اطمینان بالا",
    desc: "خرید سرور مجازی در کنار بهره‌مندی از تکنولوژی «کلاد»، پایداری بالا و نرخ بالای آپ‌تایم تا ۹۹.۹۹ درصد را به همراه دارد.",
    imgAlt: "اطمینان بالا در سرور مجازی ابری",
    imgTitle: "اطمینان بالای وی پی اس",
  },
  {
    img: "liveMigration.svg",
    title: "قابلیت Live Migration",
    desc: "به لطف «Live Migration»، با خرابی هر قطعه (حتی پردازنده)، بدون وقفه در سرویس به سخت‌افزار سالم جایگزین منتقل شوید.",
    imgAlt: "قابلیت Live Migration در سرور مجازی ابری",
    imgTitle: "قابلیت Live Migration در وی پی اس",
  },
  {
    img: "easyBuy.svg",
    title: "فرایند ساده خرید",
    desc: "فرایند خرید وی پی اس ابری تنها نیاز به طی سه مرحله ساده دارد: انتخاب مکان سرور، سیستم‌عامل و منابع مورد نیاز.",
    imgAlt: "فرایند ساده خرید سرور مجازی",
    imgTitle: "فرایند ساده خرید سرور مجازی",
  },
  {
    img: "advancedSecurity.svg",
    title: "امنیت پیشرفته",
    desc: "بالاترین سطح محافظت امنیتی به طور مداوم در سرورهای آبالون اعمال می‌شود تا خدمات کلاد شما ایمن نگه داشته شوند.",
    imgAlt: "امنیت پیشرفته سرور مجازی ابری",
    imgTitle: "امنیت پیشرفته در وی پی اس",
  },
  {
    img: "easyUse.svg",
    title: "کاربری راحت",
    desc: "پنل مدیریتی کاربردی تحت وب امکان دسترسی به تمامی تنظیمات سرور مجازی را به ساده‌ترین شکل ممکن در اختیارتان قرار می‌دهد.",
    imgAlt: "کاربری راحت سرور مجازی ابری",
    imgTitle: "کاربری راحت سرور مجازی ابری",
  },
];
const questions = [
  {
    title: "تفاوت سرور مجازی با سرور مجازی ابری چیست؟",
    answer:
      "سرور مجازی کلاد، امکاناتی پیشرفته‌تر شامل اطمینان و کیفیت سرویس بیشتر، افزایش منابع به میزان بسیار بالاتر و نیز امکان جایگزینی سخت‌افزار خراب با سالم به صورت خودکار و بدون وقفه در سرویس (به لطف Live Migration) را برایتان فراهم می‌کند.",
  },
  {
    title: "آیا می‌توان منابع سرور وی پی اس ابری را حین استفاده تغییر داد؟",
    answer:
      "بله. با توجه به این‌که VPS آبالون از تکنولوژی زیرساخت کلاد بهره می‌برد، امکان افزایش یا کاهش منابع حین سرویس فراهم است.",
  },
  {
    title: "سیستم‌عامل وی پی اس آبالون چیست؟",
    answer:
      "آبالون در خرید سرور مجازی، امکان انتخاب نسخه‌های مختلف ویندوز یا نسخه‌ها و توزیع‌های متنوع لینوکس از جمله Ubuntu ،Debian ،Fedora و CentOS را در اختیارتان می‌گذارد.",
  },
  {
    title: "آیا استفاده از سرور مجازی آبالون نیاز به تخصص دارد؟",
    answer:
      "خیر. پس از خرید VPS با سیستم‌عامل ویندوز کافی‌ست، از طریق کنسول تحت وب به سرور خود متصل شوید و پس از طی کردن مراحت تغییر پسورد ادمین، کانکشن های بعدی را از طریق همین کنسول یا از طریق ریموت دسکتاپ برقرار نمایید. در مورد سیستم‌عامل‌های لینوکس هم می‌توانید از طریق کنسول تحت وب یا SSH ارتباط را برقرار نمایید.",
  },
  {
    title: "آیا می‌توان وی پی اس را خاموش، روشن یا ری‌استارت کرد؟",
    answer:
      "بله. پنل مدیریت سرور، امکان خاموش، روشن و ری‌استارت کردن سرور را در اختیارتان قرار می‌دهد.",
  },
  {
    title: "آیا می‌توان سرور مجازی را بازسازی کرد؟",
    answer:
      "بله. با بازسازی VPS، حتی حین سرویس می‌توانید هر سیستم‌عامل دلخواه را انتخاب کنید تا مجدد روی سرور شما نصب شده و تحویل‌تان داده شود. توجه داشته باشید که با بازسازی سرور، اطلاعاتی که روی سیستم‌عامل قبلی داشتید، به صورت کامل حذف می‌شود.",
  },
];
const PopularServices = [
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری همه امکانات یک دیتاسنتر فیزیکی را روی کلاد برایتان فراهم می‌کند و می‌تواند پاسخی برای تخصصی‌ترین و پیچیده‌ترین نیازهای سازمان شما باشد.",
    logo: "VPC-Service.svg",
    route: "/vpc",
    imgAlt: "دیتاسنتر ابری",
    imgTitle: "دیتاسنتر ابری",
  },
  {
    title: "شبکه توزیع محتوا (CDN)",
    desc: "با استفاده از CDN، امنیت، سرعت بارگذاری و کیفیت سئو وب‌سایت خود را بهبود دهید و به لطف پاپ‌سایت‌های توزیع شده در جهان، داده‌های خود را سریع‌تر و بهینه‌تر به دست کاربران خود برسانید.",
    logo: "CloudGuard-Service.svg",
    route: "/cdn",
    imgAlt: "شبکه توزیع محتوا (CDN)",
    imgTitle: "شبکه توزیع محتوا (CDN)",
  },
  {
    title: "سرویس مدیریت شده",
    desc: "سرویس مدیریت شده راهکار اختصاصی مورد نیاز سازمان شما است و خدماتی از جمله نصب سیستم‌عامل و نرم‌افزارها، طراحی معماری کلاد و اجرای مهاجرت ابری را ارائه می‌کند.",
    logo: "ManagedService-Service.svg",
    route: "/manageservices",
    imgAlt: "سرویس مدیریت شده",
    imgTitle: "سرویس مدیریت شده",
  },
  {
    title: "DNS ابری",
    desc: "با DNS ابری بدون نیاز به مدیریت سرورهای DNS، زون‌ها و رکوردهای DNS تمامی دامنه‌های خود را مدیریت و در تمام جهان منتشر کنید و سرعت پاسخ‌گویی به کاربران را افزایش دهید.",
    logo: "DNS.svg",
    route: "/dns",
    imgAlt: "DNS ابری",
    imgTitle: "DNS ابری",
  },
];
const usesg = [
  {
    img: "hosting.svg",
    name: "هاست با کیفیت برای وب‌سایت",
    desc: "سرور مجازی کلاد، برای کسب‌وکارهایی که نیاز به یک هاست با کیفیت و همیشه در دسترس دارند، هوشمندانه‌ترین انتخاب است. با VPS مبتنی بر کلاد دغدغه حداکثر میزان منابع قابل دسترس، افزایش یا کاهش منابع و امکان پاسخ‌گویی به تعداد نامحدود کاربران از دوش سازمان شما برداشته می‌شود و به این ترتیب بر فعالیت‌های داخل سازمان خود متمرکز می‌شوید.",
    alt: "هاست با کیفیت برای وب‌سایت با خرید VPS",
    title: "هاست با کیفیت با خرید VPS",
  },

  {
    img: "virtualOrganization.svg",
    name: "راه‌اندازی سرور مجازی قدرتمند برای سازمان",
    desc: "اگر برای نیازهای داخلی سازمان خود از جمله سامانه‌های CRM ،ERP ،HRM ،SCM و … نیاز به زیرساخت با کیفیت دارید و در عین حال نمی‌خواهید سخت‌افزارهای گران‌قیمت، پیچیده و پر هزینه سرور را در سازمان خود راه‌اندازی کنید، وی پی اس راهکاری به‌صرفه، راحت و با کیفیت برای نیازهای شما است. با زیر ساخت VPS آبالون از دغدغه‌های راه‌اندازی و نگهداری سرورها رها می‌شوید و استفاده از سامانه‌های خود را آغاز می‌کنید.",
    alt: "خرید سرور مجازی برای سازمان",
    title: "خرید سرور مجازی برای سازمان",
  },
  {
    img: "test.svg",
    name: "اجرای پروژه دانشجویی روی سرور مجازی",
    desc: "اگر برای پروژه دانشجویی خود در جستجوی یک هاست با کیفیت هستید که با قیمت مناسب و کیفیت بالا از پس نیازهای شما بر آید، وی پی اس آبالون به شما پیشنهاد می‌شود. با این سرویس، یک سرور قدرتمند با سرعت بالا در اختیارتان قرار می‌گیرد. علاوه بر این اگر تنها برای مدت محدود نیاز به VPS دارید می‌توانید سرویس را به صورت ساعتی انتخاب نمایید.",
    alt: "خرید سرور مجازی برای پروژه دانشجویی",
    title: "خرید سرور مجازی برای پروژه دانشجویی",
  },
  {
    img: "virtualDesktop.svg",
    name: "دسکتاپ مجازی قدرتمند در دسترس از تمام جهان",
    desc: "VPS امکان دسترسی ساده و ایمن به یک دسکتاپ مجازی از هر جای جهان را فراهم می‌کند. تصور کنید به یک سفر کاری به سوی دیگری از جهان رفته‌اید و نیاز دارید برای دسترسی به سرویس‌های داخل ایران (از جمله اینترنت بانک یا سایر سرویس‌های محدود به آی‌پی‌های ایران) به یک دسکتاپ مجازی در کشور متصل شوید. برای چنین نیازهایی، سرور مجازی ویندوز به شما پیشنهاد می‌شود.",
    alt: "خرید VPS برای دسکتاپ مجازی",
    title: "خرید VPS برای دسکتاپ مجازی",
  },
  {
    img: "backup.svg",
    name: "سرور بکاپ",
    desc: "اگر سرور مجازی، اختصاصی، کلاد یا هاستینگ دیگر دارید و به دنبال راهکاری برای پشتیبان‌گیری از سرویس‌های خود هستید، وی پی اس پایدار و با کیفیت آبالون می‌‌تواند زیرساخت مورد نیاز برای بکاپ را در اختیارتان بگذارد. با پشتیبان‌گیری اطلاعات روی سرور مجازی کلاد، اطمینان پیدا می‌کنید که حتی در شرایط بحرانی هم داده‌های شما روی فضای کلاد، محفوظ خواهد ماند.",
    alt: "خرید سرور مجازی برای بکاپ",
    title: "خرید سرور مجازی برای بکاپ",
  },
  {
    img: "startupLoad.svg",
    name: "استارتاپ‌هایی با بار کاری متغیر",
    desc: "بسیاری از استارتاپ‌ها بار کاری متغیری دارند که در دوره‌های مختلف زمانی با کاهش یا افزایش مواجه می‌شود. سرور مجازی آبالون به لطف تکنولوژی کلاد، مقیاس‌پذیری بسیار بالا را در اختیارتان می‌گذارد و در هر لحظه از سرویس می‌توانید بسته به نیاز خود، میزان منابع را کاهش یا افزایش دهید. به این ترتیب در هزینه‌های خود صرفه‌جویی کرده و مطمئن می‌شوید که حتی حین افزایش بار کاری، با کمبود در منابع مواجه نخواهید شد.",
    alt: "خرید سرور مجازی برای استارتاپ",
    title: "خرید سرور مجازی برای استارتاپ",
  },
];
const locations = [
  {
    img: "iranServer.svg",
    name: "سرور مجازی ایرانی",
    cap: "سرورهای مجازی ایران در دیتاسنترهای مختلف در سراسر کشور مستقر هستند. این سرورها نسبت به سرورهای خارجی هزینه پایین‌تری داشته اما از کیفیت سرویس و آپ‌تایم بالایی برخوردار هستند و زیرساخت آنها به پردازنده‌های پر سرعت و استوریج‌های SSD مجهز شده‌ است. خرید سرور مجازی ایران به آن گروه از کسب‌وکارها و سازمان‌هایی پیشنهاد می‌شود که قصد ارائه سرویس با کیفیت و سریع به مخاطبان ایرانی را دارند.",
    alt: "خرید سرور مجازی ایران",
    title: "خرید سرور مجازی ایران",
    class: "iranImg",
  },

  {
    img: "externalServer.svg",
    name: "سرور مجازی خارجی",
    cap: "سرورهای مجازی خارجی در دیتاسنترهایی خارج از کشور واقع شده‌اند. این سرورها نسبت به سرور مجازی ایران، قیمت بالاتری داشته و در عین حال کیفیت سرویس و آپ‌تایم بالا را در اختیار شما می‌گذارند. خرید سرور مجازی خارج برای کسب‌وکارها و سازمان‌هایی پیشنهاد می‌شود که نیاز به IP خارجی دارند یا می‌خواهند خدمات خود را به کاربرانی در خارج از ایران ارائه دهند. ",
    alt: "خرید سرور مجازی خارج",
    title: "خرید سرور مجازی خارج",
    class: "externalImg",
  },
];
const serviceFeatures = [
  {
    title: "انتخاب سیستم‌عامل دلخواه",
    desc: "در فرایند خرید VPS سیستم‌عامل را از بین انواع نسخه‌های ویندوز یا لینوکس انتخاب کنید.",
    logo: "Feature-1.svg",
    imgAlt: "انتخاب سیستم‌‌عامل دلخواه حین خرید سرور مجازی",
    imgTitle: "انتخاب سیستم‌‌عامل سرور مجازی ابری",
  },
  {
    title: "تحویل در یک دقیقه",
    desc: "سرور مجازی کلاد آبالون در یک دقیقه با سیستم‌عامل دلخواه شما آماده استفاده است.",
    logo: "Feature-2.svg",
    imgAlt: "تحویل وی پی اس در یک دقیقه",
    imgTitle: "تحویل وی پی اس در یک دقیقه",
  },
  {
    title: "کنسول مدیریتی تحت وب",
    desc: "کنسول مدیریتی سرور حتی با قطع شدن دسترسی سرور به اینترنت امکان اتصال را فراهم می‌کند.",
    logo: "Feature-3.svg",
    imgAlt: "کنسول مدیریتی تحت وب سرور مجازی ابری",
    imgTitle: "کنسول وب سرور مجازی ابری",
  },
  {
    title: "دسترسی از سراسر جهان",
    desc: "از تمامی جهان و در هر لحظه به وی پی اس ایرانی یا خارجی خود دسترسی داشته باشید.",
    logo: "Feature-4.svg",
    imgAlt: "دسترسی به وی پی اس از سراسر جهان",
    imgTitle: "دسترسی به وی پی اس از سراسر جهان",
  },
  {
    title: "امکان کاهش یا افزایش منابع",
    desc: "با سرور مجازی کلاد می‌توانید در هر لحظه از سرویس منابع را افزایش یا کاهش دهید.",
    logo: "Feature-5.svg",
    imgAlt: "کاهش یا افزایش منابع وی پی اس در لحظه",
    imgTitle: "کاهش یا افزایش منابع وی پی اس",
  },
  {
    title: "پشتیبانی ۲۴/۷/۳۶۵",
    desc: "تیم پشتیبانی آبالون همه روزه و در تمامی ساعات شبانه‌روز آماده پاسخگویی به شما هستند.",
    logo: "Feature-6.svg",
    imgAlt: "پشتیبانی ۲۴ ساعته سرور مجازی ابری",
    imgTitle: "پشتیبانی ۲۴ ساعته سرور مجازی ابری",
  },
  {
    title: "فایروال قابل تنظیم",
    desc: "با فایروال قابل تنظیم وی پی اس، امکان افزودن و اعمال قوانین دلخواه برای سرور را دارید.",
    logo: "Feature-7.svg",
    imgAlt: "فایروال سرور مجازی ابری",
    imgTitle: "فایروال سرور مجازی ابری",
  },
  {
    title: "پنل ساده و کاربردی مدیریت سرور",
    desc: "پنل مدیریتی سرور امکانات روشن، خاموش، ری‌استارت و بازسازی کردن سرور را فراهم می‌کند.",
    logo: "Feature-8.svg",
    imgAlt: "پنل مدیریت سرور مجازی ابری",
    imgTitle: "پنل مدیریت سرور مجازی ابری",
  },
];

export default {
  uses,
  questions,
  PopularServices,
  usesg,
  locations,
  serviceFeatures,
};
